import {Box, Card, Grid,Step,StepContent,StepLabel,Stepper,Tab,Tabs,Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { DiscardPopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { getCachevalue, localGetItem, setCachevalue } from '../../../Utility/Services/CacheProviderService'
import { NEW_DOC_NOTES_LIST, UMA_DOCTOR_NOTES_COMPONENT } from '../../../Utility/Constants'
import { Colors } from '../../../Styles/Colors'
import UmaDocPatientCategory from './UmaDocNotes/UmaDocPatientCategory'
import UmaDocComplaints from './UmaDocNotes/UmaDocComplaints'
import UmaDocVitals from './UmaDocNotes/UmaDocVitals'
import UmaDocOcularHistory from './UmaDocNotes/UmaDocOcularHistory'
import UmaDocIllness from './UmaDocNotes/UmaDocIllness'
import UmaDocPrevGlassPower from './UmaDocNotes/UmaDocPrevGlassPower'
import UmaVisionAssessment from './UmaDocNotes/UmaVisionAssessment'
import UmaSubRefraction from './UmaDocNotes/UmaSubRefraction'
import UmaGlassPrescription from './UmaDocNotes/UmaGlassPrescription'
import UmaIntracularPressure from './UmaDocNotes/UmaIntracularPressure'
import UmaOcularResponse from './UmaDocNotes/UmaOcularResponse'
import UmaAnteriorSegment from './UmaDocNotes/UmaAnteriorSegment'
import UmaAnteriorDiagram from './UmaDocNotes/UmaAnteriorDiagram'
import UmaPosteriorSegment from './UmaDocNotes/UmaPosteriorSegment'
import UmaFundus from './UmaDocNotes/UmaFundus'
import UmaDiagnosis from './UmaDocNotes/UmaDiagnosis'
import UmaMedication from './UmaDocNotes/UmaMedication'
import UmaOtherInvestigation from './UmaDocNotes/UmaOtherInvestigation'
import UmaGoniosopy from './UmaDocNotes/UmaGoniosopy'
import UmaKeratometry from './UmaDocNotes/UmaKeratometry'
import UmaIolMaster from './UmaDocNotes/UmaIolMaster'
import UmaTreatmentPlan from './UmaDocNotes/UmaTreatmentPlan'
import UmaNotes from './UmaDocNotes/UmaNotes'
import UmaReviewPlan from './UmaDocNotes/UmaReviewPlan'
import UmaInvestigation from './UmaDocNotes/UmaInvestigation'
import UmaOptometryNotes from './UmaDocNotes/UmaOptometryNotes'
import UmaRetinoRefraction from './UmaDocNotes/UmaRetinoRefraction'
import UmaAutoRefractory from './UmaDocNotes/UmaAutoRefractory'
import UmaDocTopLayout from './UmaDocTopLayout'
import UmaCounsellor from './UmaCounsellor'
import UmaInvestigationNew from './UmaDocNotes/UmaInvestigationNew'
import UmaSmile from './UmaDocNotes/UmaSmile'
import UmaPresbyond from './UmaDocNotes/UmaPresbyond'

const doctorNotesStates = {
    patient_details: {},
    clinic_id: '',
    appointment_id: '',
    patient_id: '',
    POVList: [],
    isLocked: false,
    appointmentDate: new Date(),
    isOPT: false,
    isOPtometry: false,
    isPDdoc: false,
    doctorID: '',
    disableButton: false,
    TransferDisable: false,
    optometristName: '',
    selectedDocNotes: '',
    selectedComponent: '',
    loginUserInfo: {},
    patient_transfered: false,
    openCounsellorPopup: false,
    fromLayout: false,
    allergyData: [],
    subjRefraData: [],
    // data presence checking state
    anteriorAccordOpen: false,
    antDiagAccordOpen: false,
    posteriorAccordOpen: false,
    posDiagAccordOpen: false,
    keratoAccordOpen: false,
    gonioAccordOpen: false,
    otherInvestAccordOpen: false,
    iolMasterAccordOpen: false,
    treatAccordOpen: false,
    notesAccordOpen: false,
    reviewAccordOpen: false,
    investAccordOpen: false,
    // manual toggle state
    anteriorManualOpen: false,
    posteriorManualOpen: false,
    keratoManualOpen: false,
    otherManualOpen: false,
    treatManualOpen: false,
    reviewManualOpen: false,
    is_optos_completed: false,
}

const UmaDoctorNotes = (props) => {
    const [docSates, setDocSates] = useState(doctorNotesStates)
    const [visibleItems, setVisibleItems] = useState(0);
    const [comp, setComp] = useState('')
    const [prevComp, setPrevComp] = useState('')
    const [changeScreen, setChangeScreen] = useState(false)
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    //AUTO COMPONENT SCROLL REF
    const refractionRef = useRef(null); const glassPowerRef = useRef(null); const diagnosisRef = useRef(null);
    const medicationRef = useRef(null); const posteriorSegRef = useRef(null); const anteriorSegRef = useRef(null);
    const investigationsRef = useRef(null); const reviewPlanRef = useRef(null); const otherInvestRef = useRef(null);
    const ketometryRef = useRef(null); const gonioscopyRef = useRef(null); const iolMasterRef = useRef(null);
    const treatmentPlanRef = useRef(null); const ocularRespRef = useRef(null);const complaintsRef = useRef(null);
    const smileRef = useRef(null); const presbyondRef = useRef(null);
    // COMPONENT DATA TRANSFER REF
    const complaintData = useRef(); const categoryData = useRef(); const vitalsData = useRef();
    const ocularHistoryData = useRef(); const systemicIllnessData = useRef(); const prevGlassPowerData = useRef();
    const vissionAssestData = useRef(); const retinoRefraData = useRef(); const autoRefraData = useRef();
    const subjRefraData = useRef(); const glassPrespData = useRef(); const intraPressData = useRef();
    const ocularRespData = useRef(); const anterSegData = useRef(); const postSegData = useRef();
    const diagnosisData = useRef(); const keratomentryData = useRef(); const otherInvesData = useRef();
    const iolMasterData = useRef(); const treatPlanData = useRef(); const notesData = useRef();
    const revPlanData = useRef(); const investigationsData = useRef(); const optNotesData = useRef();
    const gonioscopyData = useRef(); const medicationData = useRef(); const smileData = useRef(); 
    const presbyondData = useRef();
    const [selectedTab, setSelectedTab] = useState(0);
    const [TrackStatus, setTrackStatus] = useState([]);

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // COMPONENT DID MOUNT
    useEffect(() => {
        let clinicId = getCachevalue('SelectedDoctorClinic')
        let patientData = JSON.parse(getCachevalue('DoctorPatientData'))
        let ServiceType = localGetItem("loggedInUserInfo")
        let myUser = JSON.parse(ServiceType)
        let POVList = localGetItem("PurposeOfVisit") === null ? '[]' : localGetItem("PurposeOfVisit")
        let array = [];
        JSON.parse(POVList).forEach(element => array.push(element.reason));
        // if (array.length > 0) {
        //     setDocSates((prev) => ({ ...prev, POVList: array }))
        // }
        setDocSates((prev) => ({
            ...prev,
            POVList: array?.length > 0 ? array : [],
            clinic_id: clinicId, appointment_id: patientData?.appointment_id,
            patient_id: patientData?.patient_id,
            isLocked:getCachevalue('DoctorUserChanged') === 'true' ? true : patientData?.transfer_appointment ? patientData?.transfer_appointment : patientData?.is_locked,
            appointmentDate: patientData?.appointment_date ? (patientData?.appointment_date).slice(0, 10) : null,
            appointmentStatus: '',
            isOPT: myUser.service_type === "OPT" ? true : false,
            isOPtometry: myUser.service_type === "OPTOMETRY" ? true : false,
            isPDdoc: myUser.service_type === "PD" ? true : false,
            doctorID: patientData?.doctor_id,
            disableButton: patientData?.transfer_appointment ? patientData?.transfer_appointment : false,
            TransferDisable: patientData?.is_transmitted ? patientData?.is_transmitted : false,
            optometristName: patientData?.optometrist_name ? patientData?.optometrist_name : "",
            loginUserInfo: JSON.parse(ServiceType),
            // patient_transfered: patientData?.is_transfered ? patientData?.is_transfered : false
            patient_transfered: patientData?.transfer_appointment ? patientData?.transfer_appointment : patientData?.is_locked,
            appointment_status: patientData?.appointment_status ? patientData?.appointment_status : "",
            is_optos_completed: patientData?.is_optos_completed || false,
        }))
        getPatientTrack(patientData?.appointment_id)
    }, [])

    const getPatientTrack = (appointment_id) => {
        try{
            RestAPIService.getAll(Serviceurls.PATIENT_TRACK_FOR_UMA + '?appointment_id=' + appointment_id)
            .then((response) => {
                if(response.data.status === 'success'){
                    setTrackStatus(response.data?.tracking)
                }
            })
            .catch((e) =>{
                if(e?.response?.data?.message){
                    errorMessage(e.response.data.message)
                }else{
                    errorMessage(e.message)
                }
            })
        }catch(e){
            errorMessage(e.message)
        }
    }

    // COMPONENT DID UPDATE
    useEffect(async () => {
        if (docSates.patient_id) {
            await getPatientDetailData()
        }
    }, [docSates.patient_id])

    const callPatientDetails = (data) => {
        setDocSates((prev) => ({ ...prev, fromLayout: data }))
    }

    useEffect(() => {
        if (docSates.fromLayout) {
            getPatientDetailData()
        }
    }, [docSates.fromLayout])

    // COMPONENT RENDER USE EFFECT ========>
    useEffect(() => {
        if (visibleItems < UMA_DOCTOR_NOTES_COMPONENT?.length) {
            const timer = setTimeout(() => {
                setVisibleItems((prev) => Math.min(prev + 4, UMA_DOCTOR_NOTES_COMPONENT?.length));
            }, 500);

            return () => clearTimeout(timer);
        }
    }, [visibleItems, UMA_DOCTOR_NOTES_COMPONENT])

    // COMPONENT DATA GET USE EFFECT =======>
    useEffect(async () => {
        if (prevComp) {
            switch (prevComp) {
                case 'Complaints':
                    return await complaintData.current.performComplaintsAction();
                case 'Category':
                    return await categoryData.current.performCategoryAction();
                case 'Vitals':
                    return await vitalsData.current.performVitalsAction();
                case 'OcularHistory':
                    return await ocularHistoryData.current.performOcularHistoryAction();
                case 'Illness':
                    return await systemicIllnessData.current.performIllnessAction();
                case 'PrevGlassPower':
                    return await prevGlassPowerData.current.performPrevGlassPowerAction();
                case 'VisionAssessment':
                    return await vissionAssestData.current.performVisionAssessmentAction();
                case 'RetinoRefraction':
                    return await retinoRefraData.current.performRetinoRefractionAction();
                case 'AutoRefractory':
                    return await autoRefraData.current.performAutoRefractoryAction();
                case 'SubRefraction':
                    return await subjRefraData.current.performSubRefractionAction();
                case 'GlassPrescription':
                    return await glassPrespData.current.performGlassPrescriptionAction();
                case 'IntracularPressure':
                    return await intraPressData.current.performIntracularPressureAction();
                case 'OcularResponse':
                    return await ocularRespData.current.performOcularResponseAction();
                case 'AnteriorSegment':
                    return await anterSegData.current.performAnteriorSegmentAction();
                case 'PosteriorSegment':
                    return await postSegData.current.performPosteriorSegmentAction();
                case 'Diagnosis':
                    return await diagnosisData.current.performDiagnosisAction();
                case 'Keratometry':
                    return await keratomentryData.current.performKeratometryAction();
                case 'OtherInvestigation':
                    return await otherInvesData.current.performOtherInvestigationAction();
                case 'IolMaster':
                    return await iolMasterData.current.performIolMasterAction();
                case 'TreatmentPlan':
                    return await treatPlanData.current.performTreatmentPlanAction();
                case 'Notes':
                    return await notesData.current.performNotesAction();
                case 'ReviewPlan':
                    return await revPlanData.current.performReviewPlanAction();
                case 'Investigation':
                    return await investigationsData.current.performInvestigationAction();
                case 'OptometryNotes':
                    return await optNotesData.current.performOptometryNotesAction();
                case 'Goniosopy':
                    return await gonioscopyData.current.performGoniosopyAction();
                case 'Medication':
                    return await medicationData.current.performMedicationAction();
                case 'Smile':
                    return await smileData.current.performSmileAction();
                case 'Presbyond':
                    return await presbyondData.current.performPresbyondAction();
            }
        }
    }, [prevComp])

    // API FUNCTION STARTS ===========>
    const getPatientDetailData = async () => {
        try {
            let response = await RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + docSates.patient_id)
            if (response.data.status === 'success') {
                setDocSates((prev) => ({
                    ...prev,
                    patient_details: response.data.data
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const lockDocNotes = (data) => {
        setDocSates((prev) => ({ ...prev, isLocked: data }))
    }
    // API FUNCTION ENDS ============>

    const updateAccordion = (manualState, dataState, dataState1, isOpen, fromManual) => {
        setDocSates((prev) => ({
            ...prev,
            ...(fromManual ?
                {
                    [manualState]: isOpen,
                    [dataState]: false,
                    [dataState1]: false
                }
                : { [dataState]: isOpen })
        }));
    };

    const scrollToComponent = (value) => {
        switch (value) {
            case 'Refraction':
                refractionRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Glass Presp.':
                glassPowerRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Diagnosis':
                diagnosisRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Medication':
                medicationRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Posterior Segment':
                posteriorSegRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Anterior Segment':
                anteriorSegRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Investigations':
                investigationsRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Review Plan':
                reviewPlanRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Other Investigation':
                otherInvestRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Ketomentry':
                ketometryRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Gonioscophy':
                gonioscopyRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'IOL Master':
                iolMasterRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Treatment Plan':
                treatmentPlanRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Ocular Response Analyzer':
                ocularRespRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Go Top':
                complaintsRef.current.scrollIntoView({ behavior: 'smooth' })
                break;
            case 'Review/Investigation':
                reviewPlanRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Smile':
                smileRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'Presbyond':
                presbyondRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (JSON.parse(getCachevalue('path_name'))) {
            setChangeScreen(true)
        }
    }, [getCachevalue('path_name')])

    const updateComponent = (curr) => {
        if (curr !== comp) {
            setCachevalue(true, 'component')
            setPrevComp(comp)
            setComp(curr)
        }
    }

    const clickedYes = () => {
        setPrevComp(comp)
        setTimeout(() => props.closeAlertPopup(), 50)
    }

    const clickedNo = () => {
        props.closeAlertPopup()
    }

    const patientHasAllergy = (data) => {
        setDocSates((prev) => ({ ...prev, allergyData: data }))
    }
    
    const patientCategoryData = (data) => {
        setDocSates((prev) => ({ ...prev, isUpdateData: Date.now() }) )
    }

    const subjectiveRefractionData = (data) => {
        setDocSates((prev) => ({
            ...prev,
            subjRefraData: data
        }))
    }

    const renderComponents = () => {
        return (
            <Box component={'div'}>
                {visibleItems > 0 ? UMA_DOCTOR_NOTES_COMPONENT?.slice(0, visibleItems)?.map((item, index) => {
                    return (
                        <Box key={index}>
                            <Grid container key={index} xs={12}>
                                {item === 'Complaints & VisionAssessment' ?
                                    <Grid xs={12} display={'flex'}>
                                        <Card elevation={comp === 'Complaints' ? 2 : 0} onClick={() => { updateComponent('Complaints') }}
                                            sx={{ border: 'Complaints' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'} ref={complaintsRef}>
                                                <UmaDocComplaints props={docSates} ref={complaintData} />
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'VisionAssessment' ? 2 : 0} onClick={() => { updateComponent('VisionAssessment') }}
                                            sx={{ border: 'VisionAssessment' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'}>
                                                <UmaVisionAssessment props={docSates} ref={vissionAssestData} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'vitals' ?
                                    <Grid xs={12} mt={'0.5rem'}>
                                        <Card elevation={comp === 'Vitals' ? 2 : 0} onClick={() => { updateComponent('Vitals') }}
                                            sx={{ border: 'Vitals' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'}>
                                                <UmaDocVitals props={docSates} ref={vitalsData} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'OcularHistory & Illness' ?
                                    <Grid xs={12} display={'flex'} mt={'0.5rem'}>
                                        <Card elevation={comp === 'OcularHistory' ? 2 : 0} onClick={() => { updateComponent('OcularHistory') }}
                                            sx={{ border: 'OcularHistory' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'}>
                                                <UmaDocOcularHistory props={docSates} ref={ocularHistoryData} />
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'Illness' ? 2 : 0} onClick={() => { updateComponent('Illness') }}
                                            sx={{ border: 'Illness' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'}>
                                                <UmaDocIllness props={docSates} ref={systemicIllnessData} patientHasAllergy={patientHasAllergy} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'PrevGlassPower & Patient Category' ?
                                    <Grid xs={12} display={'flex'} mt={'0.5rem'}>
                                        <Card elevation={comp === 'PrevGlassPower' ? 2 : 0} onClick={() => { updateComponent('PrevGlassPower') }}
                                            sx={{ border: 'PrevGlassPower' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'}>
                                                <UmaDocPrevGlassPower props={docSates} ref={prevGlassPowerData} />
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'Category' ? 2 : 0} onClick={() => { updateComponent('Category') }}
                                            sx={{ border: 'Category' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'}>
                                                <UmaDocPatientCategory props={docSates} ref={categoryData} patientCategoryData={patientCategoryData}  />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'RetinoRefraction & AutoRefractory' ?
                                    <Grid xs={12} display={'flex'} mt={'0.5rem'}>
                                        <Card elevation={comp === 'RetinoRefraction' ? 2 : 0} onClick={() => { updateComponent('RetinoRefraction') }}
                                            sx={{ border: 'RetinoRefraction' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'} ref={refractionRef}>
                                                <UmaRetinoRefraction props={docSates} ref={retinoRefraData} />
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'AutoRefractory' ? 2 : 0} onClick={() => { updateComponent('AutoRefractory') }}
                                            sx={{ border: 'AutoRefractory' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'}>
                                                <UmaAutoRefractory props={docSates} ref={autoRefraData} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'SubRefraction' ?
                                    <Grid xs={12} mt={'0.5rem'}>
                                        <Card elevation={comp === 'SubRefraction' ? 2 : 0} onClick={() => { updateComponent('SubRefraction') }}
                                            sx={{ border: 'SubRefraction' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray' }}>
                                            <Box component={'div'}>
                                                <UmaSubRefraction props={docSates} ref={subjRefraData} subjectiveRefractionData={subjectiveRefractionData} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'OptometryNotes' ?
                                    <Grid xs={12} mt={'0.5rem'}>
                                        <Card elevation={comp === 'OptometryNotes' ? 2 : 0} onClick={() => { updateComponent('OptometryNotes') }}
                                            sx={{ border: 'OptometryNotes' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray' }}>
                                            <Box component={'div'}>
                                                <UmaOptometryNotes props={docSates} ref={optNotesData} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'Smile & Presbyond' ?
                                    <Grid xs={12} display={'flex'} mt={'0.5rem'}>
                                        <Card elevation={comp === 'Smile' ? 2 : 0} onClick={() => { updateComponent('Smile') }}
                                            sx={{ border: 'Smile' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'} ref={smileRef}>
                                                <UmaSmile props={docSates} ref={smileData} syncAccordionOpen={(isOpen) => presbyondData.current?.setAccordionOpen(isOpen)} />
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'Presbyond' ? 2 : 0} onClick={() => { updateComponent('Presbyond') }}
                                            sx={{ border: 'Presbyond' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'} ref={presbyondRef}>
                                                <UmaPresbyond props={docSates} ref={presbyondData} syncAccordionOpen={(isOpen) => smileData.current?.setAccordionOpen(isOpen)} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'GlassPrescription' ?
                                    <Grid xs={12} mt={'0.5rem'}>
                                        <Card elevation={comp === 'GlassPrescription' ? 2 : 0} onClick={() => { updateComponent('GlassPrescription') }}
                                            sx={{ border: 'GlassPrescription' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray' }}>
                                            <Box component={'div'} ref={glassPowerRef}>
                                                <UmaGlassPrescription props={docSates} ref={glassPrespData} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'IntracularPressure & OcularResponse' ?
                                    <Grid xs={12} display={'flex'} mt={'0.5rem'}>
                                        <Card elevation={comp === 'IntracularPressure' ? 2 : 0} onClick={() => { updateComponent('IntracularPressure') }}
                                            sx={{ border: 'IntracularPressure' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'} ref={ocularRespRef}>
                                                <UmaIntracularPressure props={docSates} ref={intraPressData} />
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'OcularResponse' ? 2 : 0} onClick={() => { updateComponent('OcularResponse') }}
                                            sx={{ border: 'OcularResponse' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'} ref={ocularRespRef}>
                                                <UmaOcularResponse props={docSates} ref={ocularRespData} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'AnteriorSegment & AnteriorDiagram' ?
                                    <Grid xs={12} display={'flex'} mt={'0.5rem'}>
                                        <Card elevation={comp === 'AnteriorSegment' ? 2 : 0} onClick={() => { updateComponent('AnteriorSegment') }}
                                            sx={{ border: 'AnteriorSegment' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'} ref={anteriorSegRef}>
                                                <UmaAnteriorSegment props={docSates} ref={anterSegData} accordionOpen = {docSates?.anteriorManualOpen || docSates?.antDiagAccordOpen || docSates?.anteriorAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('anteriorManualOpen', 'anteriorAccordOpen', 'antDiagAccordOpen', isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'AnteriorDiagram' ? 2 : 0} onClick={() => { updateComponent('AnteriorDiagram') }}
                                            sx={{ border: 'AnteriorDiagram' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'}>
                                                <UmaAnteriorDiagram props={docSates} accordionOpen = {docSates?.anteriorManualOpen || docSates?.anteriorAccordOpen || docSates?.antDiagAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion( 'anteriorManualOpen', 'antDiagAccordOpen', "anteriorAccordOpen", isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'PosteriorSegment & Fundus' ?
                                    <Grid xs={12} display={'flex'} mt={'0.5rem'}>
                                        <Card elevation={comp === 'PosteriorSegment' ? 2 : 0} onClick={() => { updateComponent('PosteriorSegment') }}
                                            sx={{ border: 'PosteriorSegment' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'} ref={posteriorSegRef}>
                                                <UmaPosteriorSegment props={docSates} ref={postSegData} accordionOpen = {docSates?.posteriorManualOpen || docSates?.posDiagAccordOpen || docSates?.posteriorAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('posteriorManualOpen', 'posteriorAccordOpen', "posDiagAccordOpen", isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'Fundus' ? 2 : 0} onClick={() => { updateComponent('Fundus') }}
                                            sx={{ border: 'Fundus' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'}>
                                                <UmaFundus props={docSates} accordionOpen = {docSates?.posteriorManualOpen || docSates?.posteriorAccordOpen || docSates?.posDiagAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('posteriorManualOpen', 'posDiagAccordOpen', "posteriorAccordOpen", isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'Diagnosis' && docSates.isOPT ?
                                    <Grid xs={12} mt={'0.5rem'}>
                                        <Card elevation={comp === 'Diagnosis' ? 2 : 0} onClick={() => { updateComponent('Diagnosis') }}
                                            sx={{ border: 'Diagnosis' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray' }}>
                                            <Box component={'div'} ref={diagnosisRef}>
                                                <UmaDiagnosis props={docSates} ref={diagnosisData} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'Medication' && docSates.isOPT ?
                                    <Grid xs={12} mt={'0.5rem'}>
                                        <Card elevation={comp === 'Medication' ? 2 : 0} onClick={() => { updateComponent('Medication') }}
                                            sx={{ border: 'Medication' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray' }}>
                                            <Box component={'div'} ref={medicationRef}>
                                                <UmaMedication props={docSates} ref={medicationData} />
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'Keratometry & Goniosopy' ?
                                    <Grid xs={12} display={'flex'} mt={'0.5rem'}>
                                        <Card elevation={comp === 'Keratometry' ? 2 : 0} onClick={() => { updateComponent('Keratometry') }}
                                            sx={{ border: 'Keratometry' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'} ref={ketometryRef}>
                                                <UmaKeratometry props={docSates} ref={keratomentryData} accordionOpen = {docSates?.keratoManualOpen || docSates?.gonioAccordOpen || docSates?.keratoAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('keratoManualOpen', 'keratoAccordOpen', "gonioAccordOpen", isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'Goniosopy' ? 2 : 0} onClick={() => { updateComponent('Goniosopy') }}
                                            sx={{ border: 'Goniosopy' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'} ref={gonioscopyRef}>
                                                <UmaGoniosopy props={docSates} ref={gonioscopyData} accordionOpen = {docSates?.keratoManualOpen ||docSates?.keratoAccordOpen || docSates?.gonioAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('keratoManualOpen', 'gonioAccordOpen', "keratoAccordOpen",isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'OtherInvestigation & IolMaster' ?
                                    <Grid xs={12} display={'flex'} mt={'0.5rem'}>
                                        <Card elevation={comp === 'OtherInvestigation' ? 2 : 0} onClick={() => { updateComponent('OtherInvestigation') }}
                                            sx={{ border: 'OtherInvestigation' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'} ref={otherInvestRef}>
                                                <UmaOtherInvestigation props={docSates} ref={otherInvesData} accordionOpen = {docSates?.otherManualOpen || docSates?.iolMasterAccordOpen || docSates?.otherInvestAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('otherManualOpen', 'otherInvestAccordOpen', "iolMasterAccordOpen",isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'IolMaster' ? 2 : 0} onClick={() => { updateComponent('IolMaster') }}
                                            sx={{ border: 'IolMaster' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'} ref={iolMasterRef}>
                                                <UmaIolMaster props={docSates} ref={iolMasterData} accordionOpen = {docSates?.otherManualOpen || docSates?.otherInvestAccordOpen || docSates?.iolMasterAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('otherManualOpen', 'iolMasterAccordOpen', "otherInvestAccordOpen", isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'TreatmentPlan & Notes' ?
                                    <Grid xs={12} display={'flex'} mt={'0.5rem'}>
                                        <Card elevation={comp === 'TreatmentPlan' ? 2 : 0} onClick={() => { updateComponent('TreatmentPlan') }}
                                            sx={{ border: 'TreatmentPlan' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'} ref={treatmentPlanRef}>
                                                <UmaTreatmentPlan props={docSates} ref={treatPlanData} accordionOpen = {docSates?.treatManualOpen || docSates?.notesAccordOpen || docSates?.treatAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('treatManualOpen', 'treatAccordOpen', "notesAccordOpen", isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'Notes' ? 2 : 0} onClick={() => { updateComponent('Notes') }}
                                            sx={{ border: 'Notes' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'}>
                                                <UmaNotes props={docSates} ref={notesData} accordionOpen = {docSates?.treatManualOpen || docSates?.treatAccordOpen || docSates?.notesAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('treatManualOpen', 'notesAccordOpen', "treatAccordOpen", isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                                {item === 'ReviewPlan & Investigation' ?
                                    <Grid xs={12} display={'flex'} marginY={'0.5rem'}>
                                        <Card elevation={comp === 'ReviewPlan' ? 2 : 0} onClick={() => { updateComponent('ReviewPlan') }}
                                            sx={{ border: 'ReviewPlan' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5', mr: '0.5rem' }}>
                                            <Box component={'div'} ref={reviewPlanRef}>
                                                <UmaReviewPlan props={docSates} ref={revPlanData} accordionOpen = {docSates?.reviewManualOpen || docSates?.investAccordOpen || docSates?.reviewAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('reviewManualOpen', 'reviewAccordOpen', "investAccordOpen", isOpen, fromManual)}/>
                                            </Box>
                                        </Card>
                                        <Card elevation={comp === 'Investigation' ? 2 : 0} onClick={() => { updateComponent('Investigation') }}
                                            sx={{ border: 'Investigation' === comp ? `0.15vw solid ${Colors.themeDark}` : '1px solid lightgray', flex: '0.5' }}>
                                            <Box component={'div'} ref={reviewPlanRef}>
                                                {localGetItem('isNewBilling') ? <UmaInvestigationNew props={docSates} ref={investigationsData} accordionOpen = {docSates?.reviewManualOpen || docSates?.reviewAccordOpen || docSates?.investAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('reviewManualOpen', 'investAccordOpen', "reviewAccordOpen", isOpen, fromManual)}/> : 
                                                <UmaInvestigation props={docSates} ref={investigationsData} accordionOpen = {docSates?.reviewManualOpen || docSates?.reviewAccordOpen || docSates?.investAccordOpen} setAccordionOpen={(isOpen, fromManual = false) => updateAccordion('reviewManualOpen', 'investAccordOpen', "reviewAccordOpen", isOpen, fromManual)}/>}
                                            </Box>
                                        </Card>
                                    </Grid> : null}
                            </Grid>
                        </Box>
                    )
                }) : <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>Loading....</Box>}
            </Box>
        )
    }

    const onClosePopup = (message) => {
        setDocSates((prev) => ({ ...prev, openCounsellorPopup: message }))
    }

    return (
        <Box component={'div'} height={'80dvh'} sx={{ backgroundColor: Colors.Background }}>
            <Box component={'div'}>
                <UmaDocTopLayout
                    patientData={docSates}
                    lockDocNotes={lockDocNotes}
                    callPatientDetails={callPatientDetails}
                />
                <Box component={'div'} height={'70dvh'}>
                    <Grid container spacing={1} xs={12}>
                        <Grid item xs={10.5}>
                            <Box component={'div'} overflow={'auto'} height={'70dvh'} p={'0rem 0rem 0rem 0.5rem'}>
                                {renderComponents()}
                            </Box>
                        </Grid>
                        <Grid item xs={1.5}>
                            <Box borderBottom="1px solid lightgray">
                                <Tabs
                                    value={selectedTab}
                                    onChange={(event, newValue) => {
                                        setSelectedTab(newValue)
                                    }}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    sx={{ minHeight: '1vw', backgroundColor: 'white' }}
                                >
                                    <Tab sx={{ textTransform: 'capitalize', fontSize:'.8vw', minWidth: 0, width: '50%', fontWeight: 'bold'}} label="Quick View" value={0 } />
                                    <Tab sx={{ textTransform: 'capitalize', fontSize:'.8vw', minWidth: 0, width: '50%', fontWeight: 'bold' }} label="Tracking" value={1} />
                                </Tabs>
                            </Box>
                            {selectedTab == 0 ? <Box component={'div'} border={'1px solid lightgray'} overflow={'auto'} maxHeight={'62dvh'}>
                                {NEW_DOC_NOTES_LIST?.filter(list => docSates.isOPT ? list : (list?.label !== 'Medication' && list?.label !== 'Diagnosis' && list?.label !== 'Counsellor'))?.map((item, index) => {
                                    return (
                                        <Box component={'div'} key={index} p={'0.3rem'} display={'flex'} alignItems={'center'} border={'1px solid lightgray'}
                                            sx={{
                                                backgroundColor: docSates.selectedDocNotes === item?.value ? Colors.Primary : Colors.white,
                                                color: docSates.selectedDocNotes === item?.value ? Colors.white : Colors.black,
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                if (item?.label === 'Counsellor') {
                                                    setDocSates((prev) => ({ ...prev, openCounsellorPopup: true }))
                                                } else {
                                                    setDocSates((prev) => ({ ...prev, selectedDocNotes: item?.value }))
                                                    scrollToComponent(item.value)
                                                }
                                            }}
                                        >
                                            <Box component={'img'} src={item?.image} width={'1.3dvw'} height={'1.3dvw'} alt={'img'} />
                                            <Typography
                                                color={docSates.selectedDocNotes === item?.value ? Colors.white : Colors.black}
                                                fontSize={'0.9rem'} fontWeight={600} ml='0.5rem'>{item?.label}</Typography>
                                        </Box>
                                    )
                                })}
                            </Box> :
                                <Box component={'div'} border={'1px solid lightgray'} backgroundColor={'white'} overflow={'auto'} maxHeight={'62dvh'}>
                                    <Stepper orientation="vertical" nonLinear>
                                        {TrackStatus?.length > 0 ? TrackStatus.map((step, index) => (
                                            <Step key={index} active completed={index < TrackStatus.length - 1}>
                                                <StepLabel>
                                                    <Typography variant="subtitle2">{step.appointment_status || '-'}</Typography>
                                                    <Typography variant="caption" color="textSecondary">
                                                        {step.status_time || '-'}
                                                    </Typography>
                                                </StepLabel>
                                                <StepContent>
                                                    {step.comments.length > 0 ? step.comments.map((cmt, i) => (
                                                        <Typography fontSize={'0.7vw'} color={'#888888'}>
                                                            <Box component="span" fontWeight="bold" fontSize={'0.7vw'}>
                                                                {`${cmt.time || '-'} | ${cmt.date} - ${cmt.user_name || '-'}`}
                                                            </Box>
                                                            {' : '}
                                                            {cmt.comments || '-'}
                                                        </Typography>
                                                    )) :
                                                        <Typography fontSize={'0.7vw'} color={'#888888'}>
                                                            No Comments
                                                        </Typography>}

                                                </StepContent>
                                            </Step>
                                        )) : <Box component={'div'} p={'1rem'} fontSize={'1vw'}>No Tracking Data</Box>}
                                    </Stepper>
                                </Box>
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {docSates.openCounsellorPopup && <UmaCounsellor props={docSates} onClosePopup={onClosePopup} />}
            {changeScreen &&
                <DiscardPopup
                    yes={clickedYes}
                    no={clickedNo}
                    component={comp}
                />}
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

export default UmaDoctorNotes